module.exports = __webpack_public_path__ + "img/homePageimg2.d15c03b1.png";